export const IDENTITY_HUB_INLINE_SCRIPT_TAG_ID = 'wb-pubmatic-ih-pwt-inline';
export const XANDR_APPNEXUS_INLINE_SCRIPT_TAG_ID = 'xandr-appnexus-ast-inline';
export const DEMAND_MANAGER_PREBID_INLINE_SCRIPT_TAG_ID = 'demand-manager-prebid-inline';

export const ADMIRAL_AD_BLOCK_DETECT_SCRIPT = `
  !(function(o, n, t)
    {
        t = o.createElement(n)
        , o = o.getElementsByTagName(n)[0]
        , t.async = 1
        , t.src = "//rhetoricalloss.com/v2/0/lpvJm3_RkcS-vr_qgSHMbYB-jcbRkH2oNRB2URpg6t2W3jP_TPy9Na4D7qHs5MdytwG"
        , o.parentNode.insertBefore(t, o);
    })
    (document, "script"), (function(o, n)
    {
        o[n] = o[n] || function()
        {
            (o[n].q = o[n].q || []).push(arguments);
        };
    })
    (window, "admiral");
    !(function(n, e, r, t)
    {
        function o()
        {
            if ((function o(t)
            {
                try
                {
                    return (t = localStorage.getItem("v4ac1eiZr0")) && 0 < t.split(",")[4];
                }
                catch (n)
                {}
                return !1;
            })())
            {
                var t = n[e].pubads();
                typeof t.setTargeting === r && t.setTargeting("admiral-engaged", "true");
            }
        }
        (t = n[e] = n[e] || {}).cmd = t.cmd || []
        , typeof t.pubads === r ? o() : typeof t.cmd.unshift === r ? t.cmd.unshift(o) : t.cmd.push(o);
    })
    (window, "googletag", "function");
`;

export const appNexusMagnitePrebidScripts = [
    {
        code: `

            //create empty prebid object if it doesn't exist
            window.pbjs = window.pbjs || {};

            //create a queue on the prebid object        
            window.pbjs.que = window.pbjs.que || [];
                
            //load magnite script - async
            (function() {
                let doc = document;
                let spt = doc.createElement('script');
                let pos = doc.getElementsByTagName('head')[0];
                spt.type = 'text/javascript';
                spt.id = 'wb-bpjs-script-tag';
                spt.async = true;
                // spt.crossOrigin = 'anonymous';
                spt.src = 'https://micro.rubiconproject.com/prebid/dynamic/10908.js';
                pos.insertBefore(spt, pos.firstChild);
            })()
        `,
        id: DEMAND_MANAGER_PREBID_INLINE_SCRIPT_TAG_ID
    },
    {
        code: `

            //create empty apntag object if it doesn't exist
            window.apntag = window.apntag || { anq: [] };;

            //create a queue on the apntag object        
            window.apntag.anq = window.apntag.anq || [];

                
            //load ast.js - async
            (function() {
                var d = document;
                var e = d.createElement('script');
                let p = d.getElementsByTagName('head')[0];
                e.type = 'text/javascript';  
                e.async = true;
                e.id = 'wb-apntag-script-tag';
                e.crossOrigin = 'anonymous';
                e.src = 'https://adsdk.microsoft.com/ast/ast.js';
                p.insertBefore(e, p.firstChild);
            })()
        `,
        id: XANDR_APPNEXUS_INLINE_SCRIPT_TAG_ID
    }
];

export const scriptWithIdentityHubInlineScript = [
    {
        code: `
            (function() {
                var purl = window.location.href;
                var url = '//ads.pubmatic.com/AdServer/js/pwt/157739/11065';
                var profileVersionId = '';
                if (purl.indexOf('pwtv=') > 0) {
                    var regexp = /pwtv=(.*?)(&|$)/g;
                    var matches = regexp.exec(purl);
                    if (matches.length >= 2 && matches[1].length > 0) {
                        profileVersionId = '/' + matches[1];
                    }
                }
                var wtads = document.createElement('script');
                wtads.async = true;
                wtads.type = 'text/javascript';
                wtads.id = 'pubmatic-ih-pwt-url';
                wtads.src = url + profileVersionId + '/pwt.js';
                var node = document.getElementsByTagName('script')[0];
                node.parentNode.insertBefore(wtads, node);
                console.log('WB_WEB_IHPWT ---> Script tag load complete');
            })()
        `,
        id: IDENTITY_HUB_INLINE_SCRIPT_TAG_ID
    },
    ...appNexusMagnitePrebidScripts
];
export const identityHubInlineScript = [
    {
        code: `
            (function() {
                var purl = window.location.href;
                var url = '//ads.pubmatic.com/AdServer/js/pwt/157739/11065';
                var profileVersionId = '';
                if (purl.indexOf('pwtv=') > 0) {
                    var regexp = /pwtv=(.*?)(&|$)/g;
                    var matches = regexp.exec(purl);
                    if (matches.length >= 2 && matches[1].length > 0) {
                        profileVersionId = '/' + matches[1];
                    }
                }
                var wtads = document.createElement('script');
                wtads.async = true;
                wtads.type = 'text/javascript';
                wtads.id = 'pubmatic-ih-pwt-url';
                wtads.src = url + profileVersionId + '/pwt.js';
                var node = document.getElementsByTagName('script')[0];
                node.parentNode.insertBefore(wtads, node);
                console.log('WB_WEB_IHPWT ---> Script tag load complete');
            })()
        `,
        id: IDENTITY_HUB_INLINE_SCRIPT_TAG_ID
    }
];